export default "__VITE_ASSET__C5QC_obn__"